export const airBrandMap = {
  lowest: {
    icon: 'arrowDown',
    name: 'Lowest',
    key: 'Lowest',
    desc: 'Cheapest Fare',
    awardName: 'PlanAhead',
    awardCode: 'BX1A',
  },
  basic: {
    icon: 'classBasic',
    name: 'MostRestricted',
    key: 'MostRestricted',
    shortName: 'Restricted',
    desc: 'i.e. Basic',
  },
  saver: {
    icon: 'classBasic',
    name: 'Saver',
    key: 'Saver',
    shortName: 'Saver',
    desc: 'i.e. Saver',
  },

  main: {
    icon: 'classMain',
    name: 'Economy',
    key: 'Economy',
    shortName: 'Economy',
    desc: 'i.e. Main',
    awardName: 'AnyTime',
    awardCode: 'BX1D',
  },
  economy: {
    icon: 'classMain',
    name: 'Economy',
    key: 'Economy',
    shortName: 'Economy',
    desc: 'i.e. Main',
  },
  select: {
    icon: 'classPremium',
    name: 'Premium',
    key: 'Premium',
    shortName: 'Premium',
    desc: 'i.e. Comfort',
  },
  business: {
    icon: 'classBussiness',
    name: 'Luxury',
    key: 'Luxury',
    shortName: 'Luxury',
    desc: 'i.e. Business',
    awardName: 'PlanAhead',
    awardCode: 'BX1B',
  },
  first: {
    icon: 'classFirst',
    name: 'UltraLuxury',
    key: 'UltraLuxury',
    shortName: 'Ultra-lux',
    desc: 'i.e. First',
    awardName: 'AnyTime',
    awardCode: 'BX1E',
  },
  luxury: {
    icon: 'classLuxury',
    name: 'SuperLuxury',
    key: 'SuperLuxury',
    shortName: 'Super-lux',
    desc: 'i.e. Intl First',
  },
  anytime: {
    icon: 'classMain',
    name: 'Anytime',
    key: 'Anytime',
    shortName: 'Anytime',
    desc: 'i.e. Anytime SW',
  },
  wga_wn: {
    icon: 'classMain',
    name: 'WGA',
    key: 'WGA',
    shortName: 'WGA',
    desc: 'i.e. WGA',
  },
  select_wn: {
    icon: 'classPremium',
    name: 'Anytime',
    key: 'Anytime',
    shortName: 'Anytime',
    desc: 'i.e. Select SW',
  },
  first_wn: {
    icon: 'classFirst',
    name: 'Select',
    key: 'Select',
    shortName: 'Select',
    desc: 'i.e. First SW',
  },
};

export const carBrandMap = {
  city: {
    icon: 'mark',
    name: 'City',
    key: 'City',
    desc: 'i.e. City Center',
  },
  airport: {
    icon: 'airport',
    name: 'Airport',
    key: 'Airport',
    desc: 'i.e. Closest Airport',
  },
};

export const hoteBrandMap = {
  ...carBrandMap,
  payNow: {
    icon: 'cashPayment',
    name: 'Pay Now',
    key: 'PayNow',
    desc: 'i.e. Pay at Checkout',
  },
  payLater: {
    icon: 'cashPayment',
    name: 'Pay Later',
    key: 'PayLater',
    desc: 'i.e. Pay at Check-in',
  },
};

export const railBrandMap = {
  Saver: {
    icon: 'arrowDown',
    name: 'Saver',
    desc: 'i.e. Saver',
  },
  Value: {
    icon: 'classPremiumv',
    name: 'Business',
    desc: 'i.e. Business',
  },
  Business: {
    icon: 'classPremium',
    name: 'Business',
    desc: 'i.e. Business',
  },
  First: {
    icon: 'classPremium',
    name: 'Business',
    desc: 'i.e. Business',
  },
};
